import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TokenService } from './core/auth/token.service';
import { InactivityService } from './core/inactivity/inactivity.service';
import { NavigationHistoryService } from './core/navigation/navigation-history.service';
import { ErrorComponent } from './features/error/error.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ErrorComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly tokenService = inject(TokenService);
  private readonly inactivityService = inject(InactivityService);
  private readonly navigationHistory = inject(NavigationHistoryService);

  constructor() {
    this.inactivityService.start();
  }
}
